"use strict";

import { of } from "rxjs";
import { ajax } from "rxjs/ajax";
import { ofType } from "redux-observable";
import { mergeMap, catchError, map, concatMap } from "rxjs/operators";

import { requestTypes, dashboardConstants } from "../_constants";
import { getRequestHeader } from "../../_helpers/request.header";
import {
     ajaxError,
     dashBoardGetCampaignPageViewSummaryComplete,
     dashBoardGetCommsPageViewSummaryComplete,
     dashBoardGetDashboardSummaryComplete,
     dashBoardGetParticipantActivationSummaryComplete,
     dashBoardGetParticipantLoginSummaryComplete,
     dashBoardGetRewardIssuedByCampaignComplete,
     getDevicedUsedSummaryComplete,
     getEmailTrackingSummaryComplete,
     getEmailDispatchSummaryComplete,
     getAbuDhabiSummaryComplete,
     getWearTearSummaryComplete,
     getQ4OilMasterSummaryComplete,
     getAreaListComplete,
     dashBoardGetAreaManagersLeaguesRankSummaryComplete,
     dashBoardGetNotificationComplete,
     dashBoardDeleteNotificationComplete,
     dashBoardGetNotificationRequest,
     getRewardIssueByCampaignDispatchDownloadComplete,
     getParticipantActivationSummaryDispatchDownloadComplete,
     getLoginHistorySummaryDispatchDownloadComplete,
     getEmailTrackingDispatchDownloadComplete,
     getEmailDispatchDownloadComplete,
     getCommsPageViewDispatchDownloadComplete,
     getCampaignPageViewSummaryDownloadComplete,
     getDevicedUsedSummaryDispatchDownloadComplete,
     getParticipantsSliderCardDownloadComplete,
     getLocationSliderCardDownloadComplete
     
} from "../_actions";

export const dashBoardGetDashboardSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dashboardConstants.DASHBOARD_GET_DASHBOARD_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dashBoardGetDashboardSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetParticipantActivationSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_GET_PARTICIPANT_ACTIVATION_SUMMARY_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getParticipantActivationSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dashBoardGetParticipantActivationSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetRewardIssuedByCampaignEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_GET_REWARD_ISSUED_BY_CAMPAIGN_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getRewardIssuedByCampaign",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dashBoardGetRewardIssuedByCampaignComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetParticipantLoginSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_GET_PARTICIPANT_LOGIN_SUMMARY_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getParticipantLoginSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dashBoardGetParticipantLoginSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetCampaignPageViewSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_GET_CAMPAIGN_PAGE_VIEW_SUMMARY_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getCampaignPageViewSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dashBoardGetCampaignPageViewSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetCommsPageViewSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dashboardConstants.DASHBOARD_GET_COMMS_PAGE_VIEW_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getCommsPageViewSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return dashBoardGetCommsPageViewSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getEmailDispatchSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_GET_EMAIL_DISPATCH_SUMMARY_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getEmailDispatchSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getEmailDispatchSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getEmailTrackingSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_GET_EMAIL_TRACKING_SUMMARY_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getEmailTrackingSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getEmailTrackingSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getDevicedUsedSummaryEpic = (actions$) => {
    
     return actions$.pipe(
          ofType(dashboardConstants.GET_DEVICED_USED_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDevicedUsedSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getDevicedUsedSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getQ4OilMasterSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dashboardConstants.DASHBOARD_GET_Q4_OILMASTER_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getQ4OilMasterSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getQ4OilMasterSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getQ4WearTearSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dashboardConstants.DASHBOARD_GET_WEAR_TEER_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getQ4WearTearSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getWearTearSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getAbuDhabiSummaryEpic = (actions$) => {
     return actions$.pipe(
          ofType(dashboardConstants.DASHBOARD_GET_ABUDAHBI_SUMMARY_REQUEST),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getAbuDhabiSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getAbuDhabiSummaryComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const getAreaListEpic = (actions$) => {
     return actions$.pipe(
          ofType(dashboardConstants.DASHBOARD_GET_AREA_LIST_REQUEST),
          mergeMap((action) => {
               return ajax
                    .get(
                         "/api/dashboard/getAreaList",
                         getRequestHeader(requestTypes.REQUEST_TYPE_GET),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getAreaListComplete(ajaxResponse.response);
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashboardGetAreaManagersLeaguesRankSummaryEpic = (actions$) => {
     return actions$.pipe(
         ofType(
          dashboardConstants.DASHBOARD_GET_AREA_MANAGER_LEAGUES_RANK_SUMMARY_REQUEST,
         ),
         mergeMap((action) => {
             return ajax
                 .post(
                     "/api/dashboard/get-area-managers-leagues-rank-summary",
                     action.payload,
                     getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                 )
                 .pipe(
                     concatMap((ajaxResponse) => {
                         return of(
                              dashBoardGetAreaManagersLeaguesRankSummaryComplete(
                                 ajaxResponse.response,
                             ),
                         );
                     }),
                     catchError((error) => of(ajaxError(error))),
                 );
         }),
     );
 };

 export const dashBoardGetNotificationEpic = (actions$) => {
     return actions$.pipe(
         ofType(
          dashboardConstants.DASHBOARD_GET_NOTIFICATIONS_REQUEST,
         ),
         mergeMap((action) => {
             return ajax
                 .post(
                     "/api/dashboard/get-notification",
                     action.payload,
                     getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                 )
                 .pipe(
                     concatMap((ajaxResponse) => {
                         return of(
                              dashBoardGetNotificationComplete(
                                 ajaxResponse.response,
                             ),
                         );
                     }),
                     catchError((error) => of(ajaxError(error))),
                 );
         }),
     );
 };

 export const dashBoardDeleteNotificationEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_DELETE_NOTIFICATIONS_REQUEST,
          ),
          mergeMap((action) => {
               const {handleClose,  ...payload } = action.payload;

               return ajax
                    .post(
                         "/api/dashboard/delete-notification",
                         payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         concatMap((ajaxResponse) => {
                              handleClose();
                              return of(
                                   dashBoardDeleteNotificationComplete(
                                        ajaxResponse.response,
                                   ),
                                   dashBoardGetNotificationRequest({
                                   }),
                              );
                         }),
                         catchError((error) => {
                              return of(ajaxError(error));
                         }),
                    );
          }),
     );
};


export const dashBoardGetRewardIssuedByDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_REWARD_ISSUED_BY_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getRewardIssueByCampaignDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const dashBoardGetParticipantActivationSummaryDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_PARTICIPANT_ACTIVATION_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getParticipantActivationSummaryDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};


export const dashBoardGetUserLoginSummaryDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_USER_LOGIN_SUMMARY_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getLoginHistorySummaryDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetEmailTrackingSummaryDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_EMAIL_TRACKING_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getEmailTrackingDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetEmailDispatchSummaryDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_EMAIL_DISPATCH_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getEmailDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetCommsPageViewDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_COMMS_PAGE_VIEW_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getCommsPageViewDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetDevicedUsedSummaryDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_DEVICED_USED_SUMMARY_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getDevicedUsedSummaryDispatchDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetCampaignPageViewSummaryDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_CAMPAIGN_PAGE_VIEW_SUMMARY_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getCampaignPageViewSummaryDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetParticipantsSliderCardDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_PARTICIPANTS_SILDERCARD_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getParticipantsSliderCardDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};

export const dashBoardGetLocationSliderCardDownloadEpic = (actions$) => {
     return actions$.pipe(
          ofType(
               dashboardConstants.DASHBOARD_LOCATION_SILDERCARD_DOWNLOAD_REQUEST,
          ),
          mergeMap((action) => {
               return ajax
                    .post(
                         "/api/dashboard/getDashboardDownloadSummary",
                         action.payload,
                         getRequestHeader(requestTypes.REQUEST_TYPE_POST),
                    )
                    .pipe(
                         map((ajaxResponse) => {
                              return getLocationSliderCardDownloadComplete(
                                   ajaxResponse.response,
                              );
                         }),
                         catchError((error) => of(ajaxError(error))),
                    );
          }),
     );
};